import { Row, Col, Tabs, Tab } from 'react-bootstrap';
// import ProductRoleTable from "./securitypolicytable";
import styles from "./scss/huntgroup.module.scss";
import HuntGroupTable from './huntgrouptable';
const HuntGroup = () => {

  return (
    <>
      <Row className="breadcrumbarea">
        <Col sm={12}>
          <h4>Hunt Group</h4>
          <p>Route incoming calls automatically to particular teams.</p>
        </Col>
      </Row>

      <Row className={styles.mainsecurity}>
        <Col sm={12} className="nopadding">
          <div className={styles.scrolldiv}>
           <HuntGroupTable/>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default HuntGroup;